import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=33a9b168&scoped=true&"
import script from "./BannerPage.vue?vue&type=script&lang=js&"
export * from "./BannerPage.vue?vue&type=script&lang=js&"
import style0 from "./BannerPage.vue?vue&type=style&index=0&id=33a9b168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9b168",
  null
  
)

export default component.exports